module.exports = __webpack_public_path__ + "static/media/SHREYASH.1738e24c.png";